import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import jwt_decode from 'jwt-decode';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginInactiveGuard implements CanActivate {
  private router = inject(Router);
  private authenticationService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      const decoded: any = jwt_decode(currentUser.jwt_token);
      const now = new Date();
      const exp = new Date(decoded.exp * 1000);
      if (exp < now) {
        return true;
      }
    }
    if (!currentUser) {
      return true;
    }

    this.router.navigate(['ads'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
